import { Plus, Trash2 } from "lucide-react";
import { inputCls } from "../../lib/outreach";

export default function ReplyTemplatesEditor({ templates, onChange }) {
  const update = (i, k, v) => onChange(templates.map((t, j) => (j === i ? { ...t, [k]: v } : t)));
  return (
    <div data-testid="reply-templates-editor" className="mb-4">
      <label className="block text-xs font-medium text-slate-400 mb-1">Reply templates</label>
      <p className="text-[11px] text-slate-500 mb-2">Placeholders: <code className="text-amber-300">{"{first_name}"}</code>, <code className="text-amber-300">{"{company}"}</code>, <code className="text-amber-300">{"{booking_link}"}</code></p>
      <div className="space-y-3">
        {templates.map((t, i) => (
          <div key={i} className="rounded-lg border border-slate-800 p-3">
            <div className="flex gap-2 mb-2">
              <input data-testid={`template-name-${i}`} className={inputCls} value={t.name} onChange={(e) => update(i, "name", e.target.value)} placeholder="Template name" />
              <button type="button" data-testid={`template-delete-${i}`} onClick={() => onChange(templates.filter((_, j) => j !== i))} className="text-slate-500 hover:text-red-400 px-2"><Trash2 className="w-4 h-4" /></button>
            </div>
            <textarea data-testid={`template-body-${i}`} rows={5} className={inputCls} value={t.body} onChange={(e) => update(i, "body", e.target.value)} />
          </div>
        ))}
      </div>
      <button type="button" data-testid="template-add" onClick={() => onChange([...templates, { name: "", body: "" }])} className="mt-2 text-xs text-amber-400 hover:text-amber-300 inline-flex items-center gap-1"><Plus className="w-3.5 h-3.5" /> Add template</button>
    </div>
  );
}
